export default __webpack_public_path__ + "static/media/pin_blue_icon.fd60362c.svg";